import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/basic-shape-primary-circle-ellipse-round.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24m0 192a88 88 0 1 1 88-88 88.1 88.1 0 0 1-88 88" }, null, -1)])]);
}
var basic_shape_primary_circle_ellipse_round_default = { render };
//#endregion
export { basic_shape_primary_circle_ellipse_round_default as default, render };

//# sourceMappingURL=basic-shape-primary-circle-ellipse-round.svg.js.map